import { Salarie } from './../../models/salarie';
import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../models/response-api';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EsnclientService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* create client */
  createclient(body: any): Observable<ApiResponse<Salarie>> {
    return this._http.post<ApiResponse<Salarie>>(
      this._base + '/api/EsnClient/unitaryAddClient',
      body
    );
  }
  /*update client  */
  updateClient(updatedsalarieData: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/EsnClient/updateClient`,
      updatedsalarieData
    );
  }
  /*get list without pagination */
  getAllListclient() {
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/EsnClient/getListClientsWithoutPagination`
    );
  }
  /* get list salarie */
  getListclient(data: {
    per_page?: number;
    page?: number;
  }) {
   let page = 1;
   if(data?.page) {
    page = data?.page +1
   }
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/EsnClient/getListClients?per_page=${data.per_page}&page=${page}`
    );
  }
  /* get  Fournisseur by name*/
  getclientbyname(name: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/EsnClient/getCompanyByNameForClientESN?name=${name}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  /*add Bulk Candidates*/
  addBulkCandidates(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Company/addBulkClientEsn`,
      data
    );
  }
  /*get bulk candidate */
  getbulkCandidate(data: any) {
    return this._http.get(this._base + `/api/Company/exportClientEsn/${data}`, {
      responseType: 'arraybuffer',
    });
  }

  /*update client  */
  updateclient(
    salarieId: number,
    updatedsalarieData: any
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/JobRequest/update/${salarieId}`,
      updatedsalarieData
    );
  }

  // delete client
  deleteclient(salarieId: any): Observable<any> {
    return this._http.delete(
      `${this._base}/api/JobRequest/delete/${salarieId}`
    );
  }
  deleteclientt(clientFinal_id: any): Observable<any> {
    return this._http.delete(
      `${this._base}/api/EsnClient/deleteClient?clientFinal_id=${clientFinal_id}`
    );
  }

  searchClientESN(data: Record<string, any>): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      `${this._base}/api/EsnClient/searchInListClients`,
      data
    );
  }

  /*get salarie  by id */
  getclientById(
    clientFinal_id: number,
    candidate_id: number
  ): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/ConsultantClientFinal/getSalarieByIdWithDetails?clientFinal_id=${clientFinal_id}&candidate_id=${candidate_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  // search salarie//////
  searchclient(data: any): Observable<ApiResponse<any>> {
    console.log('data', data);

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/ConsultantClientFinal/searchSalariesForClientFinal`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////

  /* get list prestation */
  getListprestation(data: {
    esn_id?: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    console.log(
      'url prestation',
      `${this._base}/api/EsnClient/getListClientPrestationEnCours?esn_id=${data.esn_id}&per_page=${data.per_page}&page=${data.page}${sort}`
    );
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/EsnClient/getListClientPrestationEnCours?esn_id=${data.esn_id}&per_page=${data.per_page}&page=${data.page}${sort}`
    );
  }
  // search prestation  //////
  searchprestation(data: any): Observable<ApiResponse<any>> {
    console.log('data', data);

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/EsnClient/searchInPrestationEnCours`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  getHeaderElements(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`
    );
  }
  /* get elment of header table list candidat */
  changeDelectedElementHeader(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
      data
    );
  }
  listPageActorclientIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=14`
    );
  }
  /* change Sub Page State */
  changeSubPageStateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
  downloadcsvfileAddBulkClient() {
    const url = `${this._base}/api/Company/uploadEmptyFileAddBulkClientEsn`;
    console.log('url', url);
    return this._http.get(url, {
      responseType: 'blob', // Changer 'arraybuffer' en 'blob'
      // observe: 'response', // Permet d'obtenir la réponse complète incluant les en-têtes
    });
  }
}
